import { mouseposition } from '../global/location';
import server from './server';
import luckysheetsizeauto from './resize';
import { modelHTML } from './constant';
import { checkProtectionAuthorityNormal } from './protection';
import { getSheetIndex, getLastFocusedCellIndex, getRowColByXY } from '../methods/get';
import { setluckysheet_scroll_status } from '../methods/set';
import { replaceHtml } from '../utils/util';
import Store from '../store';
import locale from '../locale/locale';
import tooltip from '../global/tooltip';
import method from '../global/method';
export const source = {
    system: 1, // 系统
    upload: 2, // 上传
    qrCode: 3, // 二维码
    barCode: 4, // 条形码
}
export const sourceMap = {
    [source.system]: {
        defaultImg: 'data:image/png;base64,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'
    },
    [source.qrCode]: {
        defaultImg: 'data:image/png;base64,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'
    },
    [source.barCode]: {
        defaultImg: 'data:image/png;base64,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'
    },
}
const imageCtrl = {
    imgItem: {
        type: '3',  //1移动并调整单元格大小 2移动并且不调整单元格的大小 3不要移动单元格并调整其大小
        src: '',  //图片url
        source: source.upload, // 默认图片源为上传
        fx: null,
        uploadValue: [],
        originWidth: null,  //图片原始宽度
        originHeight: null,  //图片原始高度
        default: {
            width: null,  //图片 宽度
            height: null,  //图片 高度
            left: null,  //图片离表格左边的 位置
            top: null,  //图片离表格顶部的 位置
        },
        crop: {
            width: null,  //图片裁剪后 宽度
            height: null,  //图片裁剪后 高度
            offsetLeft: 0,  //图片裁剪后离未裁剪时 左边的位移
            offsetTop: 0,  //图片裁剪后离未裁剪时 顶部的位移
        },
        isFixedPos: false,  //固定位置
        fixedLeft: null,  //固定位置 左位移
        fixedTop: null,  //固定位置 右位移
        border: {
            width: 0,  //边框宽度
            radius: 0,  //边框半径
            style: 'solid',  //边框类型
            color: '#000',  //边框颜色
        }
    },
    images: null,
    currentImgId: null,
    currentWinW: null,
    currentWinH: null,
    resize: null,
    resizeXY: null,
    move: false,
    moveXY: null,
    cropChange: null,
    cropChangeXY: null,
    cropChangeObj: null,
    copyImgItemObj: null,
    insertImg: function (file) {
        const uploadImage = Store.toJsonOptions && Store.toJsonOptions['uploadImage'];
        if (typeof uploadImage === 'function') {
            // 上传形式
            uploadImage(file).then(url => {
                imageCtrl._insertImg(url);
            }).catch(error => {
                tooltip.info('<i class="fa fa-exclamation-triangle"></i>', '图片上传失败');
            });
        } else {
            // 内部base64形式
            let render = new FileReader();
            render.readAsDataURL(file);

            render.onload = function (event) {
                let src = event.target.result;
                imageCtrl._insertImg(src);
                $("#luckysheet-imgUpload").val("");
            }
        }
    },

    _insertImg: function (src) {
        let _this = this;

        let last = Store.luckysheet_select_save[Store.luckysheet_select_save.length - 1];
        let rowIndex = last.row_focus || 0;
        let colIndex = last.column_focus || 0;
        let left = colIndex == 0 ? 0 : Store.visibledatacolumn[colIndex - 1];
        let top = rowIndex == 0 ? 0 : Store.visibledatarow[rowIndex - 1];

        let image = new Image();
        image.onload = function () {
            let width = image.width,
                height = image.height;

            let img = {
                src: src,
                left: left,
                top: top,
                originWidth: width,
                originHeight: height
            }

            _this.addImgItem(img);
        }
        let imageUrlHandle = Store.toJsonOptions && Store.toJsonOptions['imageUrlHandle'];
        image.src = typeof imageUrlHandle === 'function' ? imageUrlHandle(src) : src;
    },
    generateRandomId: function (prefix) {
        if (prefix == null) {
            prefix = "img";
        }

        let userAgent = window.navigator.userAgent.replace(/[^a-zA-Z0-9]/g, "").split("");

        let mid = "";

        for (let i = 0; i < 12; i++) {
            mid += userAgent[Math.round(Math.random() * (userAgent.length - 1))];
        }

        let time = new Date().getTime();

        return prefix + "_" + mid + "_" + time;
    },
    modelHtml: function (id, imgItem) {
        let _this = this;

        let imageUrlHandle = Store.toJsonOptions && Store.toJsonOptions['imageUrlHandle'];
        let src = typeof imageUrlHandle === 'function' ? imageUrlHandle(imgItem.src) : imgItem.src;
        let imgItemParam = _this.getImgItemParam(imgItem);

        let width = imgItemParam.width * Store.zoomRatio;
        let height = imgItemParam.height * Store.zoomRatio;
        let left = imgItemParam.left * Store.zoomRatio;
        let top = imgItemParam.top * Store.zoomRatio;
        let position = imgItemParam.position;

        let borderWidth = imgItem.border.width;

        return `<div id="${id}" class="luckysheet-modal-dialog luckysheet-modal-dialog-image" style="width:${width}px;height:${height}px;padding:0;position:${position};left:${left}px;top:${top}px;z-index:200;">
                    <div class="luckysheet-modal-dialog-content" style="width:100%;height:100%;overflow:hidden;position:relative;">
                        <img src="${src}" style="position:absolute;width:${imgItem.default.width * Store.zoomRatio}px;height:${imgItem.default.height * Store.zoomRatio}px;left:${-imgItem.crop.offsetLeft * Store.zoomRatio}px;top:${-imgItem.crop.offsetTop * Store.zoomRatio}px;" />
                    </div>
                    <div class="luckysheet-modal-dialog-border" style="border:${borderWidth}px ${imgItem.border.style} ${imgItem.border.color};border-radius:${imgItem.border.radius * Store.zoomRatio}px;position:absolute;left:${-borderWidth}px;right:${-borderWidth}px;top:${-borderWidth}px;bottom:${-borderWidth}px;"></div>
                </div>`;
    },
    getSliderHtml: function () {
        let imageText = locale().imageText;

        return `<div id="luckysheet-modal-dialog-slider-imageCtrl" class="luckysheet-modal-dialog-slider luckysheet-modal-dialog-slider-imageCtrl" style="display:block;">
                    <div class="luckysheet-modal-dialog-slider-title">
                        <span>${imageText.imageSetting}</span>
                        <span class="luckysheet-model-close-btn" title="${imageText.close}">
                            <i class="fa fa-times" aria-hidden="true"></i>
                        </span>
                    </div>
                    <div class="luckysheet-modal-dialog-slider-content">
                        <div class="slider-box">
                            <div class="slider-box-title">${imageText.conventional}</div>
                            <div class="slider-box-radios">
                                <div class="radio-item">
                                    <input type="radio" id="imgItemType1" name="imgItemType" value="1">
                                    <label for="imgItemType1">${imageText.moveCell1}</label>
                                </div>
                                <div class="radio-item">
                                    <input type="radio" id="imgItemType2" name="imgItemType" value="2">
                                    <label for="imgItemType2">${imageText.moveCell2}</label>
                                </div>
                                <div class="radio-item">
                                    <input type="radio" id="imgItemType3" name="imgItemType" value="3">
                                    <label for="imgItemType3">${imageText.moveCell3}</label>
                                </div>
                            </div>
                            <div class="slider-box-checkbox">
                                <input type="checkbox" id="imgItemIsFixedPos">
                                <label for="imgItemIsFixedPos">${imageText.fixedPos}</label>
                            </div>
                        </div>
                        <div class="slider-box">
                            <div class="slider-box-title">${imageText.border}</div>
                            <div class="slider-box-borderConfig">
                                <div class="border-item">
                                    <label>${imageText.width}</label>
                                    <input type="number" id="imgItemBorderWidth" min="0">
                                </div>
                                <div class="border-item">
                                    <label>${imageText.radius}</label>
                                    <input type="number" id="imgItemBorderRadius" min="0">
                                </div>
                                <div class="border-item">
                                    <label>${imageText.style}</label>
                                    <select id="imgItemBorderStyle">
                                        <option value="solid">${imageText.solid}</option>
                                        <option value="dashed">${imageText.dashed}</option>
                                        <option value="dotted">${imageText.dotted}</option>
                                        <option value="double">${imageText.double}</option>
                                    </select>
                                </div>
                                <div class="border-item">
                                    <label>${imageText.color}</label>
                                    <div id="imgItemBorderColor" class="imgItemBorderColor">
                                        <span></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>`;
    },
    sliderHtmlShow: function () {
        let _this = this;

        $("#luckysheet-modal-dialog-slider-imageCtrl").remove();

        let sliderHtml = _this.getSliderHtml();
        $("body").append(sliderHtml);
        luckysheetsizeauto();

        let imgItem = _this.images[_this.currentImgId];

        //类型
        let type = imgItem.type;
        $("#luckysheet-modal-dialog-slider-imageCtrl #imgItemType" + type).prop("checked", true);

        //固定位置
        let isFixedPos = imgItem.isFixedPos;
        $("#luckysheet-modal-dialog-slider-imageCtrl #imgItemIsFixedPos").prop("checked", isFixedPos);

        //边框宽度
        let border = imgItem.border;
        $("#luckysheet-modal-dialog-slider-imageCtrl #imgItemBorderWidth").val(border.width);
        $("#luckysheet-modal-dialog-slider-imageCtrl #imgItemBorderRadius").val(border.radius);
        $("#luckysheet-modal-dialog-slider-imageCtrl #imgItemBorderStyle").val(border.style);
        $("#luckysheet-modal-dialog-slider-imageCtrl #imgItemBorderColor span").css("background-color", border.color).attr("title", border.color);

        _this.init();
    },
    colorSelectDialog: function (currenColor) {
        const _locale = locale();
        const locale_button = _locale.button;
        const locale_toolbar = _locale.toolbar;
        const locale_imageCtrl = _locale.imageCtrl;

        $("#luckysheet-modal-dialog-mask").show();
        $("#luckysheet-imageCtrl-colorSelect-dialog").remove();

        $("body").append(replaceHtml(modelHTML, {
            "id": "luckysheet-imageCtrl-colorSelect-dialog",
            "addclass": "luckysheet-imageCtrl-colorSelect-dialog",
            "title": locale_imageCtrl.borderTile,
            "content": `<div class="currenColor">
                            ${locale_imageCtrl.borderCur}:<span title="${currenColor}" style="background-color:${currenColor}"></span>
                        </div>
                        <div class="colorshowbox"></div>`,
            "botton": `<button id="luckysheet-imageCtrl-colorSelect-dialog-confirm" class="btn btn-primary">${locale_button.confirm}</button>
                        <button class="btn btn-default luckysheet-model-close-btn">${locale_button.cancel}</button>`,
            "style": "z-index:100003"
        }));
        let $t = $("#luckysheet-imageCtrl-colorSelect-dialog")
            .find(".luckysheet-modal-dialog-content")
            .css("min-width", 300)
            .end(),
            myh = $t.outerHeight(),
            myw = $t.outerWidth();
        let winw = $(window).width(), winh = $(window).height();
        let scrollLeft = $(document).scrollLeft(), scrollTop = $(document).scrollTop();
        $("#luckysheet-imageCtrl-colorSelect-dialog").css({
            "left": (winw + scrollLeft - myw) / 2,
            "top": (winh + scrollTop - myh) / 3
        }).show();

        //初始化选择颜色插件
        $("#luckysheet-imageCtrl-colorSelect-dialog").find(".colorshowbox").spectrum({
            showPalette: true,
            showPaletteOnly: true,
            preferredFormat: "hex",
            clickoutFiresChange: false,
            showInitial: true,
            showInput: true,
            flat: true,
            hideAfterPaletteSelect: true,
            showSelectionPalette: true,
            showButtons: false,//隐藏选择取消按钮
            maxPaletteSize: 8,
            maxSelectionSize: 8,
            color: currenColor,
            cancelText: locale_button.cancel,
            chooseText: locale_toolbar.confirmColor,
            togglePaletteMoreText: locale_toolbar.customColor,
            togglePaletteLessText: locale_toolbar.collapse,
            togglePaletteOnly: true,
            clearText: locale_toolbar.clearText,
            noColorSelectedText: locale_toolbar.noColorSelectedText,
            localStorageKey: "spectrum.textcolor" + server.gridKey,
            palette: [
                ["#000", "#444", "#666", "#999", "#ccc", "#eee", "#f3f3f3", "#fff"],
                ["#f00", "#f90", "#ff0", "#0f0", "#0ff", "#00f", "#90f", "#f0f"],
                ["#f4cccc", "#fce5cd", "#fff2cc", "#d9ead3", "#d0e0e3", "#cfe2f3", "#d9d2e9", "#ead1dc"],
                ["#ea9999", "#f9cb9c", "#ffe599", "#b6d7a8", "#a2c4c9", "#9fc5e8", "#b4a7d6", "#d5a6bd"],
                ["#e06666", "#f6b26b", "#ffd966", "#93c47d", "#76a5af", "#6fa8dc", "#8e7cc3", "#c27ba0"],
                ["#c00", "#e69138", "#f1c232", "#6aa84f", "#45818e", "#3d85c6", "#674ea7", "#a64d79"],
                ["#900", "#b45f06", "#bf9000", "#38761d", "#134f5c", "#0b5394", "#351c75", "#741b47"],
                ["#600", "#783f04", "#7f6000", "#274e13", "#0c343d", "#073763", "#20124d", "#4c1130"]
            ],
            move: function (color) {
                if (color != null) {
                    color = color.toHexString();
                }
                else {
                    color = "#000";
                }

                $("#luckysheet-imageCtrl-colorSelect-dialog .currenColor span").css("background-color", color).attr("title", color);
            }
        });
    },
    init: function () {
        let _this = this;

        //关闭
        $("#luckysheet-modal-dialog-slider-imageCtrl .luckysheet-model-close-btn").click(function () {
            $("#luckysheet-modal-dialog-slider-imageCtrl").hide();
            luckysheetsizeauto();
        });

        //常规
        $("#luckysheet-modal-dialog-slider-imageCtrl").off("change.radio").on("change.radio", ".radio-item input[type=radio][name=imgItemType]", function () {
            _this.configChange("type", this.value);
        })

        //固定位置
        $("#luckysheet-modal-dialog-slider-imageCtrl").off("change.checkbox").on("change.checkbox", ".slider-box-checkbox input[type=checkbox]", function () {
            _this.configChange("fixedPos", this.checked);
        })

        //边框宽度
        $("#luckysheet-modal-dialog-slider-imageCtrl").off("change.borderWidth").on("change.borderWidth", "#imgItemBorderWidth", function () {
            _this.configChange("border-width", this.valueAsNumber);
        })

        //边框半径
        $("#luckysheet-modal-dialog-slider-imageCtrl").off("change.borderRadius").on("change.borderRadius", "#imgItemBorderRadius", function () {
            _this.configChange("border-radius", this.valueAsNumber);
        })

        //边框样式
        $("#luckysheet-modal-dialog-slider-imageCtrl").off("change.borderStyle").on("change.borderStyle", "#imgItemBorderStyle", function () {
            _this.configChange("border-style", this.value);
        })

        //边框颜色 选择
        $("#luckysheet-modal-dialog-slider-imageCtrl").off("click.color").on("click.color", "#imgItemBorderColor", function () {
            let currenColor = $(this).find("span").attr("title");
            _this.colorSelectDialog(currenColor);
        })

        //边框选择颜色 确定
        $(document).off("click.selectColorConfirm").on("click.selectColorConfirm", "#luckysheet-imageCtrl-colorSelect-dialog-confirm", function () {
            let $parent = $(this).parents("#luckysheet-imageCtrl-colorSelect-dialog");
            $("#luckysheet-modal-dialog-mask").hide();
            $parent.hide();

            let currenColor = $parent.find(".currenColor span").attr("title");
            $("#luckysheet-modal-dialog-slider-imageCtrl #imgItemBorderColor span").css("background-color", currenColor).attr("title", currenColor);

            _this.configChange("border-color", currenColor);
        });

        //image active
        $("#luckysheet-image-showBoxs").off("mousedown.active").on("mousedown.active", ".luckysheet-modal-dialog-image", function (e) {


            if (!checkProtectionAuthorityNormal(Store.currentSheetIndex, "editObjects", false)) {
                return;
            }

            $(this).hide();
            let id = $(this).attr("id");

            if (_this.currentImgId != null && _this.currentImgId != id) {
                _this.cancelActiveImgItem();
            }

            _this.currentImgId = id;

            let item = _this.images[id];
            let imgItemParam = _this.getImgItemParam(item);

            let width = imgItemParam.width * Store.zoomRatio;
            let height = imgItemParam.height * Store.zoomRatio;
            let left = imgItemParam.left * Store.zoomRatio;
            let top = imgItemParam.top * Store.zoomRatio;
            let position = imgItemParam.position;

            $("#luckysheet-modal-dialog-activeImage").show().css({
                "width": width,
                "height": height,
                "left": left,
                "top": top,
                "position": position
            });
            let imageUrlHandle = Store.toJsonOptions && Store.toJsonOptions['imageUrlHandle'];
            let imgUrl = typeof imageUrlHandle === 'function' ? imageUrlHandle(item.src) : item.src;
            $("#luckysheet-modal-dialog-activeImage .luckysheet-modal-dialog-content").css({
                "background-image": "url(" + imgUrl + ")",
                "background-size": item.default.width * Store.zoomRatio + "px " + item.default.height * Store.zoomRatio + "px",
                "background-position": -item.crop.offsetLeft * Store.zoomRatio + "px " + -item.crop.offsetTop * Store.zoomRatio + "px"
            })

            $("#luckysheet-modal-dialog-activeImage .luckysheet-modal-dialog-border").css({
                "border-width": item.border.width * Store.zoomRatio,
                "border-style": item.border.style,
                "border-color": item.border.color,
                "border-radius": item.border.radius * Store.zoomRatio,
                "left": -item.border.width * Store.zoomRatio,
                "right": -item.border.width * Store.zoomRatio,
                "top": -item.border.width * Store.zoomRatio,
                "bottom": -item.border.width * Store.zoomRatio,
            })

            // _this.sliderHtmlShow();
            // 执行'openImgConfigDialog' hook回调
            if (item.source === source.qrCode) {
                method.createHookFunction('openQrCodeDialog', id);
            } else if (item.source === source.barCode) {
                method.createHookFunction('openBarCodeDialog', id);
            } else {
                method.createHookFunction('openImgConfigDialog', id);

            }

            e.stopPropagation();
        })

        //image move
        $("#luckysheet-modal-dialog-activeImage").off("mousedown.move").on("mousedown.move", ".luckysheet-modal-dialog-content", function (e) {
            if (!checkProtectionAuthorityNormal(Store.currentSheetIndex, "editObjects", false)) {
                return;
            }

            if (!$("#luckysheet-modal-dialog-slider-imageCtrl").is(":visible")) {
                // _this.sliderHtmlShow();
            }

            _this.move = true;

            _this.currentWinW = $("#luckysheet-cell-main")[0].scrollWidth;
            _this.currentWinH = $("#luckysheet-cell-main")[0].scrollHeight;

            let offset = $("#luckysheet-modal-dialog-activeImage").offset();

            _this.moveXY = [
                e.pageX - offset.left,
                e.pageY - offset.top,
            ];

            setluckysheet_scroll_status(true);

            e.stopPropagation();
        })

        //image resize
        $("#luckysheet-modal-dialog-activeImage").off("mousedown.resize").on("mousedown.resize", ".luckysheet-modal-dialog-resize-item", function (e) {
            if (!checkProtectionAuthorityNormal(Store.currentSheetIndex, "editObjects", false)) {
                return;
            }

            _this.currentWinW = $("#luckysheet-cell-main")[0].scrollWidth;
            _this.currentWinH = $("#luckysheet-cell-main")[0].scrollHeight;

            _this.resize = $(this).data("type");

            let scrollTop = $("#luckysheet-cell-main").scrollTop(),
                scrollLeft = $("#luckysheet-cell-main").scrollLeft();
            let mouse = mouseposition(e.pageX, e.pageY);
            let x = mouse[0] + scrollLeft;
            let y = mouse[1] + scrollTop;

            let position = $("#luckysheet-modal-dialog-activeImage").position();
            let width = $("#luckysheet-modal-dialog-activeImage").width();
            let height = $("#luckysheet-modal-dialog-activeImage").height();

            _this.resizeXY = [
                x,
                y,
                width,
                height,
                position.left + scrollLeft,
                position.top + scrollTop,
                scrollLeft,
                scrollTop
            ];

            setluckysheet_scroll_status(true);

            e.stopPropagation();
        })

        //image croppingEnter
        $("#luckysheet-modal-dialog-activeImage").off("mousedown.croppingEnter").on("mousedown.croppingEnter", ".luckysheet-modal-controll-crop", function (e) {
            _this.croppingEnter();
            e.stopPropagation();
        })

        //image croppingExit
        $("#luckysheet-modal-dialog-cropping").off("mousedown.croppingExit").on("mousedown.croppingExit", ".luckysheet-modal-controll-crop", function (e) {
            _this.croppingExit();
            e.stopPropagation();
        })

        //image crop change
        $("#luckysheet-modal-dialog-cropping").off("mousedown.cropChange").on("mousedown.cropChange", ".resize-item", function (e) {
            _this.cropChange = $(this).data("type");

            let scrollTop = $("#luckysheet-cell-main").scrollTop(),
                scrollLeft = $("#luckysheet-cell-main").scrollLeft();
            let mouse = mouseposition(e.pageX, e.pageY);
            let x = mouse[0] + scrollLeft;
            let y = mouse[1] + scrollTop;

            _this.cropChangeXY = [
                x,
                y
            ];

            setluckysheet_scroll_status(true);

            e.stopPropagation();
        })

        //image restore
        $("#luckysheet-image-showBoxs").off("mousedown.restore").on("mousedown.restore", ".luckysheet-modal-controll-restore", function (e) {
            _this.restoreImgItem();
            e.stopPropagation();
        })

        //image delete
        $("#luckysheet-image-showBoxs").off("mousedown.delete").on("mousedown.delete", ".luckysheet-modal-controll-del", function (e) {
            _this.removeImgItem();
            e.stopPropagation();
        })
    },
    configChange: function (type, value) {
        let _this = this;

        let imgItem = _this.images[_this.currentImgId];

        switch (type) {
            case "type":
                imgItem.type = value;
                break;
            case "fixedPos":
                imgItem.isFixedPos = value;

                let imgItemParam = _this.getImgItemParam(imgItem);
                let width = imgItemParam.width;
                let height = imgItemParam.height;
                let left = imgItemParam.left;
                let top = imgItemParam.top;
                let position = imgItemParam.position;

                $("#luckysheet-modal-dialog-activeImage").show().css({
                    "width": width,
                    "height": height,
                    "left": left,
                    "top": top,
                    "position": position
                });
                break;
            case "border-width":
                imgItem.border.width = value;
                $("#luckysheet-modal-dialog-activeImage .luckysheet-modal-dialog-border").css({
                    "border-width": value,
                    "left": -value,
                    "right": -value,
                    "top": -value,
                    "bottom": -value
                });
                break;
            case "border-radius":
                imgItem.border.radius = value;
                $("#luckysheet-modal-dialog-activeImage .luckysheet-modal-dialog-border").css("border-radius", value);
                break;
            case "border-style":
                imgItem.border.style = value;
                $("#luckysheet-modal-dialog-activeImage .luckysheet-modal-dialog-border").css("border-style", value);
                break;
            case "border-color":
                imgItem.border.color = value;
                $("#luckysheet-modal-dialog-activeImage .luckysheet-modal-dialog-border").css("border-color", value);
                break;
        }

        _this.ref();
    },
    getImgItemParam (imgItem) {
        let isFixedPos = imgItem.isFixedPos;

        let width = imgItem.default.width,
            height = imgItem.default.height,
            left = imgItem.default.left,
            top = imgItem.default.top;

        if (imgItem.crop.width != width || imgItem.crop.height != height) {
            width = imgItem.crop.width;
            height = imgItem.crop.height;
            left += imgItem.crop.offsetLeft;
            top += imgItem.crop.offsetTop;
        }

        let position = 'absolute';
        if (isFixedPos) {
            position = 'fixed';
            left = imgItem.fixedLeft + imgItem.crop.offsetLeft;
            top = imgItem.fixedTop + imgItem.crop.offsetTop;
        }

        return {
            width: width,
            height: height,
            left: left,
            top: top,
            position: position
        }
    },
    cancelActiveImgItem: function () {
        let _this = this;

        $("#luckysheet-modal-dialog-activeImage").hide();
        $("#luckysheet-modal-dialog-cropping").hide();
        $("#luckysheet-modal-dialog-slider-imageCtrl").hide();

        let imgItem = _this.images[_this.currentImgId];
        if (!imgItem) return;
        let imgItemParam = _this.getImgItemParam(imgItem);

        let width = imgItemParam.width * Store.zoomRatio;
        let height = imgItemParam.height * Store.zoomRatio;
        let left = imgItemParam.left * Store.zoomRatio;
        let top = imgItemParam.top * Store.zoomRatio;
        let position = imgItemParam.position;

        $("#" + _this.currentImgId).show().css({
            "width": width,
            "height": height,
            "left": left,
            "top": top,
            "position": position
        });
        $("#" + _this.currentImgId + " img").css({
            "width": imgItem.default.width * Store.zoomRatio,
            "height": imgItem.default.height * Store.zoomRatio,
            "left": -imgItem.crop.offsetLeft * Store.zoomRatio,
            "top": -imgItem.crop.offsetTop * Store.zoomRatio
        });
        $("#" + _this.currentImgId + " .luckysheet-modal-dialog-border").css({
            "border-width": imgItem.border.width * Store.zoomRatio,
            "border-style": imgItem.border.style,
            "border-color": imgItem.border.color,
            "border-radius": imgItem.border.radius * Store.zoomRatio,
            "left": -imgItem.border.width * Store.zoomRatio,
            "right": -imgItem.border.width * Store.zoomRatio,
            "top": -imgItem.border.width * Store.zoomRatio,
            "bottom": -imgItem.border.width * Store.zoomRatio,
        })

        _this.currentImgId = null;
    },
    addImgItem: function (img, autoFocus = false, callback,) {
        let _this = this;

        let width = img.originWidth, height = img.originHeight;

        if (_this.images == null) {
            _this.images = {};
        }
        // 获取最后一次聚焦的cell
        const { rowIndex, colIndex } = getLastFocusedCellIndex();

        let imgItem = $.extend(true, {}, _this.imgItem);
        imgItem.rowIndex = rowIndex;
        imgItem.colIndex = colIndex;
        imgItem.src = img.src;
        imgItem.fx = img.fx;
        imgItem.uploadValue = img.uploadValue;
        imgItem.source = img.source;
        imgItem.originWidth = img.originWidth;
        imgItem.originHeight = img.originHeight;
        imgItem.default.width = width;
        imgItem.default.height = height;
        imgItem.default.left = img.left;
        imgItem.default.top = img.top;
        imgItem.crop.width = width;
        imgItem.crop.height = height;
        if (img.source === source.qrCode) {
            imgItem.qrCodeInfo = {
                'errorCorrectionLevel': img.errorCorrectionLevel
            }
        } else if (img.source === source.barCode) {
            imgItem.barCodeInfo = {
                'type': img.type,
                'showText': img.showText,
                'fontSize': img.fontSize,
            }
        }

        let scrollTop = $("#luckysheet-cell-main").scrollTop(),
            scrollLeft = $("#luckysheet-cell-main").scrollLeft();

        imgItem.fixedLeft = img.left - scrollLeft + Store.rowHeaderWidth;
        imgItem.fixedTop = img.top - scrollTop + Store.infobarHeight + Store.toolbarHeight + Store.calculatebarHeight + Store.columnHeaderHeight;

        let id = _this.generateRandomId();
        let modelHtml = _this.modelHtml(id, imgItem);

        $("#luckysheet-image-showBoxs .img-list").append(modelHtml);

        _this.images[id] = imgItem;
        callback && callback(id, imgItem);
        _this.ref();

        _this.init();

        if (autoFocus) {
            $(`#luckysheet-image-showBoxs #${id}`).trigger("mousedown.active");
        }
    },
    moveImgItem: function () {
        let _this = this;

        _this.move = false;

        let obj = $("#luckysheet-modal-dialog-activeImage")[0];
        let item = _this.images[_this.currentImgId];

        if (item.isFixedPos) {
            // 这里要除以缩放比例得到100%缩放情况下的真实left和top
            item.fixedLeft = (obj.offsetLeft - item.crop.offsetLeft) / Store.zoomRatio;
            item.fixedTop = (obj.offsetTop - item.crop.offsetTop) / Store.zoomRatio;
        }
        else {
            // 这里要除以缩放比例得到100%缩放情况下的真实left和top
            item.default.left = (obj.offsetLeft - item.crop.offsetLeft) / Store.zoomRatio;
            item.default.top = (obj.offsetTop - item.crop.offsetTop) / Store.zoomRatio;
            // 更新colIndex,rowIndex信息
            const { overflowColumnIndex, overflowRowIndex } = getRowColByXY(item.default.left, item.default.top);
            item.rowIndex = overflowRowIndex;
            item.colIndex = overflowColumnIndex;
        }

        _this.ref();
    },
    resizeImgItem: function () {
        let _this = this;
        _this.resize = null;

        let obj = $("#luckysheet-modal-dialog-activeImage")[0];

        let item = _this.images[_this.currentImgId];
        let scaleX = obj.clientWidth / item.crop.width;
        let scaleY = obj.clientHeight / item.crop.height;

        item.default.width = Math.round(item.default.width * scaleX);
        item.default.height = Math.round(item.default.height * scaleY);

        item.crop.width = Math.round(item.crop.width * scaleX);
        item.crop.height = Math.round(item.crop.height * scaleY);
        item.crop.offsetLeft = Math.round(item.crop.offsetLeft * scaleX);
        item.crop.offsetTop = Math.round(item.crop.offsetTop * scaleY);

        if (item.isFixedPos) {
            item.fixedLeft = obj.offsetLeft;
            item.fixedTop = obj.offsetTop;
        }
        else {
            item.default.left = obj.offsetLeft - item.crop.offsetLeft;
            item.default.top = obj.offsetTop - item.crop.offsetTop;
        }
        // 缩放后调用hook
        method.createHookFunction('imageResizeAfter', item)

        _this.ref();
    },
    croppingEnter: function () {
        let _this = this;
        _this.cropping = true;

        if (!checkProtectionAuthorityNormal(Store.currentSheetIndex, "editObjects", false)) {
            return;
        }

        $("#luckysheet-modal-dialog-activeImage").hide();
        $("#luckysheet-modal-dialog-slider-imageCtrl").hide();

        let item = _this.images[_this.currentImgId];
        let imgItemParam = _this.getImgItemParam(item);

        let width = imgItemParam.width;
        let height = imgItemParam.height;
        let left = imgItemParam.left;
        let top = imgItemParam.top;
        let position = imgItemParam.position;

        $("#luckysheet-modal-dialog-cropping").show().css({
            "width": width,
            "height": height,
            "left": left,
            "top": top,
            "position": position
        });

        let imageUrlHandle = Store.toJsonOptions && Store.toJsonOptions['imageUrlHandle'];
        let imgSrc = typeof imageUrlHandle === 'function' ? imageUrlHandle(item.src) : item.src;

        $("#luckysheet-modal-dialog-cropping .cropping-mask").css({
            "width": item.default.width,
            "height": item.default.height,
            "background-image": "url(" + imgSrc + ")",
            "left": -item.crop.offsetLeft,
            "top": -item.crop.offsetTop
        })

        $("#luckysheet-modal-dialog-cropping .cropping-content").css({
            "background-image": "url(" + imgSrc + ")",
            "background-size": item.default.width + "px " + item.default.height + "px",
            "background-position": -item.crop.offsetLeft + "px " + -item.crop.offsetTop + "px"
        })

        $("#luckysheet-modal-dialog-cropping .luckysheet-modal-dialog-border").css({
            "border-width": item.border.width,
            "border-style": item.border.style,
            "border-color": item.border.color,
            "border-radius": item.border.radius,
            "left": -item.border.width,
            "right": -item.border.width,
            "top": -item.border.width,
            "bottom": -item.border.width,
        })
    },
    croppingExit: function () {
        let _this = this;
        _this.cropping = false;

        $("#luckysheet-modal-dialog-cropping").hide();

        let item = _this.images[_this.currentImgId];
        let imgItemParam = _this.getImgItemParam(item);

        let width = imgItemParam.width;
        let height = imgItemParam.height;
        let left = imgItemParam.left;
        let top = imgItemParam.top;
        let position = imgItemParam.position;

        $("#luckysheet-modal-dialog-activeImage").show().css({
            "width": width,
            "height": height,
            "left": left,
            "top": top,
            "position": position
        });
        let imageUrlHandle = Store.toJsonOptions && Store.toJsonOptions['imageUrlHandle'];
        let imgSrc = typeof imageUrlHandle === 'function' ? imageUrlHandle(item.src) : item.src;

        $("#luckysheet-modal-dialog-activeImage .luckysheet-modal-dialog-content").css({
            "background-image": "url(" + imgSrc + ")",
            "background-size": item.default.width + "px " + item.default.height + "px",
            "background-position": -item.crop.offsetLeft + "px " + -item.crop.offsetTop + "px"
        })
    },
    cropChangeImgItem: function () {
        let _this = this;

        _this.cropChange = null;

        let item = _this.images[_this.currentImgId];
        item.crop.width = _this.cropChangeObj.width;
        item.crop.height = _this.cropChangeObj.height;
        item.crop.offsetLeft = _this.cropChangeObj.offsetLeft;
        item.crop.offsetTop = _this.cropChangeObj.offsetTop;

        _this.ref();
    },
    restoreImgItem: function (imgId, size) {
        let _this = this;
        let imgItem = _this.images[imgId || _this.currentImgId];

        imgItem.default.width = size?.width || imgItem.originWidth;
        imgItem.default.height = size?.height || imgItem.originHeight;

        imgItem.crop.width = size?.width || imgItem.originWidth;
        imgItem.crop.height = size?.height || imgItem.originHeight;
        imgItem.crop.offsetLeft = 0;
        imgItem.crop.offsetTop = 0;

        let imgItemParam = _this.getImgItemParam(imgItem);

        let width = imgItemParam.width;
        let height = imgItemParam.height;
        let left = imgItemParam.left;
        let top = imgItemParam.top;
        let position = imgItemParam.position;

        $("#luckysheet-modal-dialog-activeImage").show().css({
            "width": width,
            "height": height,
            "left": left,
            "top": top,
            "position": position
        });

        let imageUrlHandle = Store.toJsonOptions && Store.toJsonOptions['imageUrlHandle'];
        let imgSrc = typeof imageUrlHandle === 'function' ? imageUrlHandle(imgItem.src) : imgItem.src;

        $("#luckysheet-modal-dialog-activeImage .luckysheet-modal-dialog-content").css({
            "background-image": "url(" + imgSrc + ")",
            "background-size": imgItem.default.width + "px " + imgItem.default.height + "px",
            "background-position": -imgItem.crop.offsetLeft + "px " + -imgItem.crop.offsetTop + "px"
        })

        // 钩子 imageDeleteAfter
        method.createHookFunction('imageRecoverAfter', imgItem, _this.currentImgId);
        _this.ref();
    },
    removeImgItem: function () {
        let _this = this;
        let imgItem = _this.images[_this.currentImgId];

        // 钩子 imageDeleteBefore
        if (!method.createHookFunction('imageDeleteBefore', imgItem)) {
            return;
        }

        $("#luckysheet-modal-dialog-activeImage").hide();
        $("#luckysheet-modal-dialog-cropping").hide();
        $("#luckysheet-modal-dialog-slider-imageCtrl").hide();
        $("#" + _this.currentImgId).remove();


        delete _this.images[_this.currentImgId];
        const cacheImgId = _this.currentImgId;
        _this.currentImgId = null;

        // 钩子 imageDeleteAfter
        method.createHookFunction('imageDeleteAfter', imgItem, cacheImgId);
        _this.ref();
    },
    copyImgItem: function (e) {
        let _this = this;

        _this.copyImgItemObj = $.extend(true, {}, _this.images[_this.currentImgId]);

        let clipboardData = window.clipboardData; //for IE
        if (!clipboardData) { // for chrome
            clipboardData = e.originalEvent.clipboardData;
        }

        let cpdata = '<table data-type="luckysheet_copy_action_image"><tr><td><td></tr></table>';

        if (!clipboardData) {
            let textarea = $("#luckysheet-copy-content");
            textarea.html(cpdata);
            textarea.focus();
            textarea.select();
            document.execCommand("selectAll");
            document.execCommand("Copy");
            // 等50毫秒，keyPress事件发生了再去处理数据
            setTimeout(function () {
                $("#luckysheet-copy-content").blur();
            }, 10);
        }
        else {
            clipboardData.setData('Text', cpdata);
            return false;//否则设不生效
        }
    },
    pasteImgItem: function () {
        let _this = this;

        if (_this.images == null) {
            _this.images = {};
        }

        let rowIndex = Store.luckysheet_select_save[0].row_focus || 0;
        let colIndex = Store.luckysheet_select_save[0].column_focus || 0;
        let left = colIndex == 0 ? 0 : Store.visibledatacolumn[colIndex - 1];
        let top = rowIndex == 0 ? 0 : Store.visibledatarow[rowIndex - 1];

        let img = $.extend(true, {}, _this.copyImgItemObj);

        img.default.left = left - img.crop.offsetLeft;
        img.default.top = top - img.crop.offsetTop;

        let scrollTop = $("#luckysheet-cell-main").scrollTop(),
            scrollLeft = $("#luckysheet-cell-main").scrollLeft();

        img.fixedLeft = img.default.left - scrollLeft + Store.rowHeaderWidth;
        img.fixedTop = img.default.top - scrollTop + Store.infobarHeight + Store.toolbarHeight + Store.calculatebarHeight + Store.columnHeaderHeight;

        let id = _this.generateRandomId();
        let modelHtml = _this.modelHtml(id, img);

        $("#luckysheet-image-showBoxs .img-list").append(modelHtml);

        _this.images[id] = img;
        _this.ref();

        _this.init();
    },
    allImagesShow: function () {
        let _this = this;

        $("#luckysheet-modal-dialog-activeImage").hide();
        $("#luckysheet-modal-dialog-cropping").hide();
        $("#luckysheet-modal-dialog-slider-imageCtrl").hide();
        $("#luckysheet-image-showBoxs .img-list").empty();

        if (_this.images == null) {
            return;
        }

        for (let imgId in _this.images) {
            let imgItem = _this.images[imgId];
            let modelHtml = _this.modelHtml(imgId, imgItem);
            $("#luckysheet-image-showBoxs .img-list").append(modelHtml);
        }
    },
    moveChangeSize: function (rc, index, size) {
        let _this = this;
        let images = $.extend(true, {}, _this.images);

        if (rc == "row") {
            let row = Store.visibledatarow[index],
                row_pre = index - 1 == -1 ? 0 : Store.visibledatarow[index - 1];
            let changeSize = size - (row - row_pre - 1);

            for (let imgId in images) {
                let imgItem = images[imgId];
                let imgItemParam = _this.getImgItemParam(imgItem);
                let type = imgItem.type;

                if (type == "1") {
                    if (imgItemParam.top >= row) {
                        imgItem.default.top = imgItemParam.top + changeSize - imgItem.crop.offsetTop;
                    }
                    else {
                        if (imgItemParam.top + imgItemParam.height >= row - 2) {
                            if (imgItemParam.top < row + changeSize) {
                                let scaleY = (imgItemParam.height + changeSize) / imgItemParam.height;
                                imgItem.default.height = Math.round(imgItem.default.height * scaleY);
                                imgItem.crop.height = Math.round(imgItem.crop.height * scaleY);
                                imgItem.crop.offsetTop = Math.round(imgItem.crop.offsetTop * scaleY);
                            }
                            else {
                                let scaleY = (imgItemParam.top + imgItemParam.height - row) / imgItemParam.height;
                                imgItem.default.height = Math.round(imgItem.default.height * scaleY);
                                imgItem.crop.height = Math.round(imgItem.crop.height * scaleY);
                                imgItem.crop.offsetTop = Math.round(imgItem.crop.offsetTop * scaleY);
                                imgItem.default.top = row + changeSize - imgItem.crop.offsetTop;
                            }
                        }
                        else {
                            if (imgItemParam.top > row + changeSize) {
                                let scaleY = 1 / imgItemParam.height;
                                imgItem.default.height = Math.round(imgItem.default.height * scaleY);
                                imgItem.crop.height = Math.round(imgItem.crop.height * scaleY);
                                imgItem.crop.offsetTop = Math.round(imgItem.crop.offsetTop * scaleY);
                                imgItem.default.top = row + changeSize - imgItem.crop.offsetTop;
                            }
                            else if (imgItemParam.top + imgItemParam.height > row + changeSize) {
                                let scaleY = (row + changeSize - imgItemParam.top) / imgItemParam.height;
                                imgItem.default.height = Math.round(imgItem.default.height * scaleY);
                                imgItem.crop.height = Math.round(imgItem.crop.height * scaleY);
                                imgItem.crop.offsetTop = Math.round(imgItem.crop.offsetTop * scaleY);
                            }
                        }
                    }
                }
                else if (type == "2") {
                    if (imgItemParam.top >= row) {
                        imgItem.default.top = imgItemParam.top + changeSize - imgItem.crop.offsetTop;
                    }
                    else if (imgItemParam.top > row + changeSize) {
                        imgItem.default.top = row + changeSize - imgItem.crop.offsetTop;
                    }
                }
            }
        }
        else if (rc == "column") {
            let col = Store.visibledatacolumn[index],
                col_pre = index - 1 == -1 ? 0 : Store.visibledatacolumn[index - 1];
            let changeSize = size - (col - col_pre - 1);

            for (let imgId in images) {
                let imgItem = images[imgId];
                let imgItemParam = _this.getImgItemParam(imgItem);
                let type = imgItem.type;

                if (type == "1") {
                    if (imgItemParam.left >= col) {
                        imgItem.default.left = imgItemParam.left + changeSize - imgItem.crop.offsetLeft;
                    }
                    else {
                        if (imgItemParam.left + imgItemParam.width >= col - 2) {
                            if (imgItemParam.left < col + changeSize) {
                                let scaleX = (imgItemParam.width + changeSize) / imgItemParam.width;
                                imgItem.default.width = Math.round(imgItem.default.width * scaleX);
                                imgItem.crop.width = Math.round(imgItem.crop.width * scaleX);
                                imgItem.crop.offsetLeft = Math.round(imgItem.crop.offsetLeft * scaleX);
                            }
                            else {
                                let scaleX = (imgItemParam.left + imgItemParam.width - col) / imgItemParam.width;
                                imgItem.default.width = Math.round(imgItem.default.width * scaleX);
                                imgItem.crop.width = Math.round(imgItem.crop.width * scaleX);
                                imgItem.crop.offsetLeft = Math.round(imgItem.crop.offsetLeft * scaleX);
                                imgItem.default.left = col + changeSize - imgItem.crop.offsetLeft;
                            }
                        }
                        else {
                            if (imgItemParam.left > col + changeSize) {
                                let scaleX = 1 / imgItemParam.width;
                                imgItem.default.width = Math.round(imgItem.default.width * scaleX);
                                imgItem.crop.width = Math.round(imgItem.crop.width * scaleX);
                                imgItem.crop.offsetLeft = Math.round(imgItem.crop.offsetLeft * scaleX);
                                imgItem.default.left = col + changeSize - imgItem.crop.offsetLeft;
                            }
                            else if (imgItemParam.left + imgItemParam.width > col + changeSize) {
                                let scaleX = (col + changeSize - imgItemParam.left) / imgItemParam.width;
                                imgItem.default.width = Math.round(imgItem.default.width * scaleX);
                                imgItem.crop.width = Math.round(imgItem.crop.width * scaleX);
                                imgItem.crop.offsetLeft = Math.round(imgItem.crop.offsetLeft * scaleX);
                            }
                        }
                    }
                }
                else if (type == "2") {
                    if (imgItemParam.left >= col) {
                        imgItem.default.left = imgItemParam.left + changeSize - imgItem.crop.offsetLeft;
                    }
                    else if (imgItemParam.left > col + changeSize) {
                        imgItem.default.left = col + changeSize - imgItem.crop.offsetLeft;
                    }
                }
            }
        }

        return images;
    },
    ref: function () {
        let _this = this;

        let file = Store.luckysheetfile[getSheetIndex(Store.currentSheetIndex)];
        let images = _this.images;

        if (Store.clearjfundo) {
            Store.jfundo.length = 0;

            Store.jfredo.push({
                "type": "imageCtrl",
                "sheetIndex": Store.currentSheetIndex,
                "images": file.images == null ? null : $.extend(true, {}, file.images),
                "curImages": images
            });
        }

        file.images = $.extend(true, {}, images);
        server.saveParam("all", Store.currentSheetIndex, file.images, { "k": "images" });
    },
}

export default imageCtrl;
